"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateMachine = exports.StateMachinesProvider = void 0;
const react_1 = require("react");
const StateMachines_1 = require("./StateMachines");
const StateMachinesContext = react_1.createContext(StateMachines_1.createStateMachineRegistry());
const { Provider } = StateMachinesContext;
exports.StateMachinesProvider = Provider;
const getActions = (states) => Object.keys(states)
    .map(key => {
    const state = states[key];
    const actions = Object.keys(state.on || {});
    return state.states ? getActions(state.states).concat(actions) : actions;
})
    .reduce((a, b) => a.concat(b), [])
    .filter((key, pos, arr) => arr.indexOf(key) === pos);
exports.useStateMachine = (machine) => {
    const validActions = react_1.useMemo(() => getActions(machine.config.states), [
        machine,
    ]);
    const registry = react_1.useContext(StateMachinesContext);
    const machineStateRef = react_1.useRef(machine.initialState);
    const onTransitionMachine = react_1.useCallback((getState, action) => {
        if (validActions.includes(action.type)) {
            machineStateRef.current = machine.transition(machineStateRef.current, action, getState());
        }
    }, [machine, validActions]);
    const getCurrentMachineState = react_1.useCallback(() => machineStateRef.current.value, [machineStateRef]);
    react_1.useEffect(() => {
        registry.register(onTransitionMachine);
        return () => {
            registry.unregister(onTransitionMachine);
        };
    }, [onTransitionMachine, registry]);
    return getCurrentMachineState;
};
